import React, { Component } from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { withRouter } from 'react-router-dom'
import ReactTable from 'react-table'
import {
  Button,
  Form,
  Modal,
  Popconfirm,
  Input,
  AutoComplete,
  Tabs,
  Icon,
  message,
  Tooltip,
  Select
} from 'antd'
import styled from 'styled-components'
import Loader from '../../common/Loader'
import CreateContactForm from '../../../components/CreateContactForm'
import Jobs from '../../../components/jobs/contacts/Jobs'
import Leads from '../../../components/jobs/contacts/Leads'
import Notes from '../../../components/jobs/contacts/Notes'
import { actions as jobContactActions } from '../../../redux/modules/jobFunctions/jobContactActions'
import { actions as companiesActions } from '../../../redux/modules/companiesActions'
import { actions as contactsActions } from '../../../redux/modules/contactsActions'
import {
  convertNamesToOption,
  filterCaseInsensitive,
  listEmails,
  listPhoneNumbers
} from '../../../util'
import history from '../../../history'
import _ from 'lodash'

const TabPane = Tabs.TabPane
const FormItem = Form.Item
const Option = Select.Option
const propTypes = {}

const ListBox = styled.div`
  border: 1px solid #eaeaea;
  border-radius: 5px;
  padding: 10px;
  margin-bottom: 10px;
`

class JobContacts extends Component {
  constructor(props) {
    super(props)
    this.state = {
      modalIsShowing: false,
      currentId: 0,
      contentData: null,
      primaryContact: 0,
      tabKey: '1',
      showOkButton: false,
      contactGroupsState: null,
      isEditing: false,
      selectedGroup: null,
      groupName: null
    }

    this.props.jobContactsRefresh({
      jobId: this.props.jobId
    })

    this.props.fetchContactGroupsByJobId({
      jobId: this.props.jobId
    })
  }

  handleRowClick = row => {
    this.setState({
      modalVisible: true,
      currentId: row.id,
      contentData: row,
      primaryContact: row.primary_contact
    })

    this.props.getContactLeads({
      contactId: row.id
    })

    this.props.getContactJobs({
      contactId: row.id
    })

    this.props.getContactNote({
      contactId: row.id
    })
  }

  handleAddButton = () => {
    this.props.getAllContacts()
    this.props.getAllCompanies()
    this.setState({
      modalVisible: true,
      currentId: 0,
      contentData: null
    })
  }

  handleCreateGroup = async () => {
    const { jobId, user } = this.props

    this.props.createJobContactGroup({
      jobId: jobId,
      userId: user.userId
    })
  }

  handleCancel = () => {
    this.props.form.resetFields()
    this.setState({ data: [], currentId: 0, modalVisible: false, primaryContact: 0 })
  }

  handleEditGroup = e => {
    this.setState({
      selectedGroup: e.currentTarget.id,
      isEditing: true
    })
  }

  handleSaveGroup = async () => {
    const { jobId } = this.props

    this.props.updateJobContactGroup({
      groupId: this.state.selectedGroup,
      name: this.state.groupName,
      jobId
    })

    this.setState({
      selectedGroup: null,
      isEditing: false
    })
  }

  handleDeleteGroup = async () => {
    const { jobId } = this.props

    this.props.deleteJobContactGroup({
      groupId: this.state.selectedGroup,
      jobId
    })

    this.setState({
      selectedGroup: null,
      isEditing: false
    })
  }

  handleCreate = () => {
    if (this.state.tabKey === '2') {
      this.setState({
        tabKey: '1'
      })
    }
    const form = this.props.form
    form.validateFields((err, values) => {
      if (this.state.currentId !== 0) {
        this.props.updateJobContact({
          jobId: this.props.jobId,
          contactId: this.state.currentId,
          content: this.state.primaryContact,
          userId: this.props.user.userId
        })
        form.resetFields()
        message.success('Changes saved.')
        this.setState({ contentData: null, currentId: 0, modalVisible: false, primaryContact: 0 })
        return
      } else {
        if (err) {
          return
        }
        this.props.addJobContact({
          jobId: this.props.jobId,
          content: values,
          userId: this.props.user.userId
        })

        form.resetFields()
        message.success('Changes saved.')
        this.setState({ contentData: null, currentId: 0, modalVisible: false })
      }
    })
  }

  confirmDelete = event => {
    const form = this.props.form

    this.props.removeJobContact({
      contactId: this.state.currentId,
      jobId: this.props.jobId
    })

    form.resetFields()
    message.success('Record deleted.')
    this.setState({
      contentData: null,
      currentId: 0,
      modalVisible: false
    })
  }

  handleChangeTab = key => {
    this.setState({
      showOkButton: +key === 2 ? true : false
    })

    this.setState({
      tabKey: key
    })
  }

  handleCreateContact = contact => {
    this.props.createContact(contact)
    this.setState({
      tabKey: '1',
      contentData: null,
      showOkButton: false
    })
  }

  handleUpdateJobPrimaryContact = contactId => {
    this.props.updateJobPrimaryContact({
      contactId: contactId,
      jobId: this.props.jobId
    })
  }

  handleContactShortcut = row => {
    history.push(`/contacts/${row.id}`)
  }

  handleUpdateJobPrimaryContact = contactId => {
    this.props.updateJobPrimaryContact({
      contactId: contactId,
      jobId: this.props.jobId
    })
  }

  render() {
    const { contentData } = this.state

    const contactGroups = _.get(this.props, 'contactsActions.contactGroups.data')
    const jobContacts = _.get(this.props, 'jobContactActions.jobContacts.data')

    const { getFieldDecorator } = this.props.form
    if (!jobContacts) {
      return <Loader />
    }
    return (
      <div>
        <Modal
          visible={this.state.modalVisible}
          title="Contacts"
          okText={contentData ? 'Save Changes' : 'Add Contact'}
          onCancel={this.handleCancel}
          onOk={this.handleCreate}
          width={contentData ? '90%' : 800}
          okButtonProps={{ disabled: this.state.showOkButton }}
          maskClosable={false}
        >
          {contentData && (
            <div>
              <div className="row">
                <div className="col-10">
                  <h3>{`${contentData.first_name} ${contentData.last_name}`}</h3>
                  <h5>{contentData.organization_name}</h5>
                </div>
                <div className="col-2">
                  <Button
                    size="normal"
                    icon="export"
                    onClick={() => this.handleContactShortcut(contentData)}
                  >
                    Go to Contact detail
                  </Button>
                </div>
              </div>
              <div className="row">
                <div className="col-6">
                  <div>Emails: </div>
                  <ListBox>{listEmails(contentData.email_list)}</ListBox>
                </div>
                <div className="col-6">
                  <div>Phone Numbers: </div>
                  <ListBox>{listPhoneNumbers(contentData.phone_list)}</ListBox>
                </div>
              </div>
              <div className="row">
                <div className="col-6">
                  <Leads
                    contactLeads={
                      this.props.contactsActions.contactLeads &&
                      this.props.contactsActions.contactLeads.data
                    }
                  />
                </div>
                <div className="col-6">
                  <Jobs
                    contactJobs={
                      this.props.contactsActions.contactJobs &&
                      this.props.contactsActions.contactJobs.data
                    }
                  />
                </div>
              </div>
              <div className="row">
                <div className="col-6">
                  <Notes
                    contactNotes={
                      this.props.contactsActions &&
                      this.props.contactsActions.contactsNotes &&
                      this.props.contactsActions.contactsNotes.data
                    }
                  />
                </div>
              </div>
            </div>
          )}
          {!contentData &&
            contactGroups && (
              <Tabs
                defaultActiveKey="1"
                activeKey={this.state.tabKey}
                onChange={this.handleChangeTab}
              >
                <TabPane tab="Select" key="1">
                  <Form layout="vertical">
                    <div className="row">
                      <div className="col-6">
                        <FormItem label="Contact">
                          {getFieldDecorator('contact', {
                            rules: [
                              {
                                required: true,
                                message: 'Find your contact'
                              }
                            ],
                            initialValue: contentData ? contentData.contact : ''
                          })(
                            <AutoComplete
                              dataSource={
                                this.props.contactsActions && this.props.contactsActions.allContacts
                                  ? convertNamesToOption(
                                      this.props.contactsActions.allContacts.data
                                    )
                                  : []
                              }
                              filterOption={(inputValue, option) =>
                                option.props.children
                                  .toUpperCase()
                                  .indexOf(inputValue.toUpperCase()) !== -1
                              }
                              style={{ width: 320 }}
                              placeholder="Search for a contact"
                            >
                              <Input
                                suffix={<Icon type="search" className="certain-category-icon" />}
                              />
                            </AutoComplete>
                          )}
                        </FormItem>
                      </div>
                      <div className="col-6">
                        <FormItem label="Contact Group">
                          {getFieldDecorator('contact_group_id', {
                            rules: [
                              {
                                required: true,
                                message: 'Please select the contact group'
                              }
                            ],
                            initialValue: contentData ? contentData.contact : ''
                          })(
                            <Select>
                              {contactGroups.map(contactGroup => {
                                return (
                                  <Option key={contactGroup.id} value={contactGroup.id}>
                                    {contactGroup.name}
                                  </Option>
                                )
                              })}
                            </Select>
                          )}
                        </FormItem>
                      </div>
                    </div>
                  </Form>
                </TabPane>
                <TabPane tab="Create" key="2">
                  <CreateContactForm
                    contentData={this.state.contentData}
                    allOrganizations={
                      this.props.companiesActions.payload &&
                      this.props.companiesActions.payload.data
                    }
                    createContact={this.handleCreateContact}
                    user={this.props.user}
                  />
                </TabPane>
              </Tabs>
            )}
          <Popconfirm
            title="Are you sure you want to delete this record?"
            onConfirm={this.confirmDelete}
            onCancel={this.cancelDelete}
            okText="Yes"
            cancelText="No"
          >
            {contentData && <Button type="danger" icon="delete" />}
          </Popconfirm>
        </Modal>

        <div className="jobsBar">
          Job Contacts
          <div className="jobsBarButtons">
            <div className="jobsBarAdd">
              <i className="fa fa-plus-square" aria-hidden="true" />
              &nbsp;<div onClick={() => this.handleCreateGroup()} className="addJobLabel">
                ADD Group
              </div>
            </div>
            <div className="jobsBarAdd">
              <i className="fa fa-plus-square" aria-hidden="true" />
              &nbsp;<div onClick={() => this.handleAddButton()} className="addJobLabel">
                ADD Contact
              </div>
            </div>
          </div>
        </div>
        {jobContacts &&
          contactGroups && (
            <div className="row">
              {contactGroups.map(contactGroup => {
                return (
                  <div className="col-6" key={`${contactGroup.id}${contactGroup.name}`}>
                    {(!this.state.isEditing || this.state.selectedGroup != contactGroup.id) && (
                      <div style={{ display: 'flex' }}>
                        <h5 style={{ marginTop: 20 }}>{contactGroup.name}</h5>
                        <Button
                          id={contactGroup.id}
                          icon="edit"
                          className="marginRight10"
                          onClick={e => this.handleEditGroup(e)}
                          style={{ marginTop: 15, marginLeft: 5 }}
                        />
                      </div>
                    )}
                    {this.state.isEditing &&
                      this.state.selectedGroup == contactGroup.id && (
                        <div style={{ display: 'flex' }}>
                          <Input
                            style={{ width: '30%', height: 40, marginTop: 10, marginBottom: 10 }}
                            defaultValue={contactGroup.name}
                            onChange={e => this.setState({ groupName: e.target.value })}
                          />
                          <Button
                            icon="save"
                            className="marginRight10"
                            onClick={() => this.handleSaveGroup()}
                            style={{ marginTop: 15, marginLeft: 5, marginRight: 0 }}
                          />
                          <Button
                            icon="delete"
                            className="marginRight10"
                            onClick={() => this.handleDeleteGroup()}
                            style={{ marginTop: 15, marginLeft: 5 }}
                          />
                        </div>
                      )}

                    <ReactTable
                      filterable
                      defaultFilterMethod={filterCaseInsensitive}
                      defaultPageSize={5}
                      getTdProps={(state, rowInfo, column, instance) => ({
                        onClick: () => {
                          if (column.Header !== 'Primary') {
                            this.handleRowClick(rowInfo.original)
                          }
                        }
                      })}
                      data={_.filter(jobContacts, jobContact => {
                        return jobContact.contact_group_id === contactGroup.id
                      })}
                      columns={[
                        {
                          columns: [
                            {
                              Header: 'Name',
                              id: 'name',
                              accessor: 'first_name',
                              Cell: d => {
                                const r = `${d.original.first_name} ${d.original.last_name}`
                                return <Tooltip title={r}>{r}</Tooltip>
                              }
                            },
                            {
                              Header: 'Title',
                              id: 'title',
                              accessor: 'title',
                              Cell: d => (
                                <Tooltip title={d.original.title}>{d.original.title}</Tooltip>
                              )
                            },

                            {
                              Header: 'Email',
                              accessor: 'email',
                              Cell: row => {
                                const r = listEmails(row.original.email_list)
                                return <Tooltip title={r}>{r}</Tooltip>
                              }
                            },
                            {
                              Header: 'Primary',
                              accessor: 'primary',
                              Cell: d => (
                                <div>
                                  <Popconfirm
                                    title="Are you sure you want to make this the primary address for this Job?"
                                    onConfirm={() =>
                                      this.handleUpdateJobPrimaryContact(d.original.id)
                                    }
                                    onCancel={this.cancelDelete}
                                    okText="Yes"
                                    cancelText="No"
                                  >
                                    <Button
                                      size="small"
                                      icon={
                                        d.original.primary_contact === d.original.id
                                          ? 'check'
                                          : 'close'
                                      }
                                      type="link"
                                      style={{ color: '#1F45B4' }}
                                    />
                                  </Popconfirm>
                                </div>
                              ),
                              width: 100
                            }
                          ]
                        }
                      ]}
                      className="-striped -highlight"
                    />
                  </div>
                )
              })}
            </div>
          )}
      </div>
    )
  }
}

const mapStateToProps = ({ jobContactActions, companiesActions, contactsActions }, ownProps) => ({
  jobContactActions,
  companiesActions,
  contactsActions
})

const mapDispatchToProps = (dispatch, ownProps) => ({
  ...bindActionCreators(
    Object.assign({}, jobContactActions, companiesActions, contactsActions),
    dispatch
  )
})

JobContacts.propTypes = propTypes
export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Form.create()(JobContacts)))



// WEBPACK FOOTER //
// ./src/containers/job/tasks/JobContacts.js